/**
 * Initialises the component when passed an element
 *
 * @param {HTMLNode} rootElement The component dom node
 */
export default function(rootElement) {
  if (!rootElement) {
    return false;
  }

  const init = () => {
    const wrapper = rootElement.querySelector('.sdc-article-youtube__inner');
    wrapper.innerHTML = wrapper.innerHTML.replace(/(<!--|-->)/g, '');
  };

  if (!window.sdc || !window.sdc.checkConsent) {
    init();
    rootElement.dataset.consent = 'true';
    return;
  }

  window.sdc.checkConsent(rootElement, init);
}
